import React, { Component } from "react";

import {
  TableCell,
  TableHead,
  TableBody,
  Table,
  TableRow
} from "@material-ui/core";
import styled from "styled-components";
import shortid from "shortid";

const StyledTableContainer = styled.div`
  && {
    width: 1000px;
  }
`;
const StyledHeaderCell = styled(TableCell)`
  && {
    font-weight: bold;
    text-align: right;
    font-size: 17px;
    color: black;
    background-color: #fff;
    padding: 0;
  }
  &&:first-child {
    padding-left: 5px;
  }
  &&:last-child {
    padding-right: 5px;
  }
`;

const StyledDateHeader = styled(StyledHeaderCell)`
  && {
    text-align: left;
  }
`;
const StyledTableCell = styled(TableCell)`
  && {
    font-size: 17px;
    color: black;
    text-align: right;
    white-space: nowrap;
  }
  &&:last-child {
    padding-right: 5px;
  }
`;

const StyledDateCell = styled(StyledTableCell)`
  && {
    text-align: left;
    padding-left: 5px;
  }
`;

class Libor extends Component {
  state = {};

  formatNumber = num => {
    return (
      new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 5,
        maximumFractionDigits: 7
      }).format(num) + "%"
    );
  };

  shouldComponentUpdate(nextProps) {
    return this.props.libor !== nextProps.libor;
  }

  render() {
    const { libor } = this.props;

    return (
      <>
        <StyledTableContainer>
          <Table className="tableBlueHover">
            <TableHead>
              <TableRow>
                <StyledDateHeader padding="none">Date</StyledDateHeader>
                <StyledHeaderCell padding="none">
                  Reset (1 Month)
                </StyledHeaderCell>
                <StyledHeaderCell padding="none">
                  Reset (3 Month)
                </StyledHeaderCell>
                <StyledHeaderCell padding="none">
                  Reset (6 Month)
                </StyledHeaderCell>
                <StyledHeaderCell padding="none">
                  Term SOFR
                </StyledHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {libor ? (
                libor.map(item => (
                  <TableRow key={shortid.generate()} hover>
                    <StyledDateCell padding="none">{item.date}</StyledDateCell>
                    <StyledTableCell padding="none">
                      {this.formatNumber(item.reset)}
                    </StyledTableCell>
                    <StyledTableCell padding="none">
                      {this.formatNumber(item.reset3)}
                    </StyledTableCell>
                    <StyledTableCell padding="none">
                      {this.formatNumber(item.reset6)}
                    </StyledTableCell>
                    <StyledTableCell padding="none">
                      {this.formatNumber(item.reset12)}
                    </StyledTableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell />
                  <TableCell />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
      </>
    );
  }
}

export default Libor;
